import { downloadBlob } from './download-blob'

export const downloadCSV = (csvString: string, filename: string = 'data.csv'): void => {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
  downloadBlob(blob, filename)
}
